export default __webpack_public_path__ + "static/media/OpenGL-00.d1a8f648.jpg";